import mainView from "./mainView";

/**
 * Handle's the rendering of popular tv show cards in the page.
 *
 * Extends of {@link mainView}
 */
class popularTVsView extends mainView {
  _title = "Popular TV's";
}

export default new popularTVsView();
